import "./polyfills";
import "./i18next";

import { createInertiaApp } from "@inertiajs/react";
import { createRoot } from "react-dom/client";

createInertiaApp({
	resolve: async (name) => {
		const pages = import.meta.glob("./Pages/**/*.tsx");
		const module = await pages[`./Pages/${name}.tsx`]?.();
		return typeof module === "object" && module && "default" in module ?
				module.default
			:	undefined;
	},
	setup({ el, App, props }) {
		createRoot(el).render(<App {...props} />);
	},
});
